import axios from "./axios";
import { deleteOrderingMenuURL } from "./requests";

export const deleteOrderingMenuApi = (token: string) => {
  return axios.delete(deleteOrderingMenuURL, {
    headers: { token },
  });
};
